module.exports = __webpack_public_path__ + "img/b40e0fc.png";